import React from 'react'
import styled from 'styled-components'
import BackImage from '../../assets/bg-logos.png'

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${BackImage}) repeat;
  background-size: 9rem;
  opacity: .1;
  z-index: -20;
  transition: all 1s cubic-bezier(0.99, 0.15, 0, 0.86);
`

const StampBg = () => {
  return <Background />
}

export default StampBg